<template>
    <div>
        <div v-if="team">
            <update-team-photo :team="team" :isTeamAdmin="isTeamAdmin"></update-team-photo>

            <update-team-name :team="team" :isTeamAdmin="isTeamAdmin"></update-team-name>

            <template v-if="impersonator && isTeamAdmin">
                <update-team-dashboard :team="team"></update-team-dashboard>

                <update-estimated-number-throughput :team="team" />

                <update-team-short-url :team="team"></update-team-short-url>

                <update-team-utm-parameters :team="team"></update-team-utm-parameters>
            </template>
        </div>
    </div>
</template>

<script>
import UpdateTeamPhoto from './UpdateTeamPhoto.vue';
import UpdateTeamName from './UpdateTeamName.vue';
import UpdateTeamDashboard from './UpdateTeamDashboard.vue';
import UpdateTeamShortUrl from './UpdateTeamShortUrl.vue';
import UpdateTeamUtmParameters from './UpdateTeamUtmParameters.vue';
import UpdateEstimatedNumberThroughput from './UpdateEstimatedNumberThroughput.vue';

export default {
    props: ['team', 'isTeamAdmin', 'impersonator'],
    inject: ['FEATURES'],
    components: {
        UpdateEstimatedNumberThroughput,
        UpdateTeamPhoto,
        UpdateTeamName,
        UpdateTeamDashboard,
        UpdateTeamShortUrl,
        UpdateTeamUtmParameters,
    }
}
</script>
